import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { useState } from 'react';
import { useRemoveFileOnRemote } from '@/service/serverless-gpu/hook';
import { toast } from 'sonner';

type DialogDeleteFileProps = {
  path: string;
  projectId: string;
};
const DialogContentDeleteFile = ({
  path,
  projectId,
}: DialogDeleteFileProps) => {
  const { mutateAsync: removeFile, isPending: isRemoving } =
    useRemoveFileOnRemote();

  const handleDelete = () => {
    toast.promise(
      removeFile({
        project_id: projectId!,
        project_path: [path],
      }),
      {
        loading: 'Deleting...',
        success: 'File deleted successfully',
        error: 'Failed to delete file',
      }
    );
  };

  return (
    <DialogContent>
      <DialogHeader>
        <DialogTitle>Delete File</DialogTitle>
      </DialogHeader>
      <p>Are you sure you want to delete this file?</p>
      <DialogFooter>
        <DialogClose asChild>
          <Button variant="outline">
            Cancel
          </Button>
        </DialogClose>
        <DialogClose asChild>
          <Button
            variant="destructive"
            onClick={handleDelete}
            disabled={isRemoving}
          >
            Delete
          </Button>
        </DialogClose>
      </DialogFooter>
    </DialogContent>
  );
};

export default DialogContentDeleteFile;
